<div class="width-1100">

  <mat-card>

    <mat-toolbar class="toolbar-top">

      <div class='title' style='padding: 10px;'>
        Inscrições
      </div>

      <button mat-button (click)='goBack()'>
        <mat-icon>arrow_back</mat-icon>
      </button>

    </mat-toolbar>

  </mat-card>

  <div class='div-progress'>
    <mat-progress-bar [ngClass]="{hidden: !spinner}" color='primary' mode="indeterminate">
    </mat-progress-bar>
  </div>

  <div style="width: 500px; margin: auto;">

    <div *ngIf="alreadySubscribed">

      <mat-card>
        <div style="padding: 5px;">
          INSCRIÇÃO CONFIRMADA
        </div>
        <div style="padding: 5px;">
          Nome: {{_frontDeskService.currentMember.name }}
        </div>
        <div style="padding: 5px;">
          CPF: {{_frontDeskService.currentMember.cpf }}
        </div>

      </mat-card>

      <button mat-raised-button (click)='printTicket()' class="button">
        Imprimir Crachá
      </button>

      <mat-card *ngIf='showTicket'>

        <div style="font-family: 'Arial'; font-size: 16px; color: black; padding: 10px; margin-top: 20px; text-align: center; border: solid 1px silver; border-radius: 5px;">
          <div>
            <b style="text-transform: uppercase;">{{_frontDeskService.currentMember.shortName }}</b>
          </div>
          <div>
            <i>{{_frontDeskService.currentMember.subCategory.name }}</i>
          </div>

          <div >
            <div style="font-size: 0.9em;" *ngFor="let order of _frontDeskService.memberOrders">
              {{order.product_name.toUpperCase()}}
            </div>
          </div>

        </div>
      </mat-card>

    </div>

    <mat-card *ngIf="!alreadySubscribed">

      <div style="padding:10px 0 10px 0; color:rgba(63,72,204,.8);">
        <b>Clique abaixo para inscrever {{_frontDeskService.currentMember.name}}</b>
      </div>

      <!-- TABLE -->
      <mat-table [dataSource]="dataSourceProducts">

        <ng-container matColumnDef="name">
          <mat-header-cell *matHeaderCellDef> Nome </mat-header-cell>
          <mat-cell *matCellDef="let element">
            {{ element.name }}
          </mat-cell>
        </ng-container>

        <!-- Header -->
        <mat-header-row *matHeaderRowDef="displayedColumnsProducts"></mat-header-row>

        <!-- Row  -->
        <mat-row (click)='getProduct(row)' *matRowDef="let row; columns: displayedColumnsProducts;"></mat-row>

      </mat-table>
      <!-- END TABLE -->

    </mat-card>

  </div>

</div>